import React, { Fragment } from 'react';
import FeaturedImage from '../FeaturedImage';

function post(props) {
  const {
    post,
    postType,
    displayAuthor,
    displayExcerpt,
    displayDate,
    displayCategories,
    acfData,
    replaceSelected,
    theExcerpt
  } = props;

  let categories;
  let categoryItems;
  let featuredImage;
  let author;
  let excerpt;
  let date;
  let categoriesElement;
  let categorySeparator = '';
  let postReadTime;

  featuredImage = <figure className="blog-post__featured-image" dangerouslySetInnerHTML={{ __html: acfData.acf_post_default_card_image }}></figure>;

  if (post.hasOwnProperty('featured_image') && post.featured_image) {
    featuredImage =
      <figure className='blog-post__featured-image'>
        <FeaturedImage
          imageSize={'archive-post-card'}
          image={post.featured_image}
          srcset={post.featured_image}
        ></FeaturedImage>
      </figure>
  }

  if (post.hasOwnProperty('the_categories') && post.the_categories.length > 0) {
    categories = post.the_categories;
  }

  if (categories && displayCategories) {
    categoryItems = categories.map((category, index) => {
      if ( 0 !== index ) {
        categorySeparator = ', ';
      }

      if (category.taxonomy === 'category') {
        return (
          <Fragment key={index}>
            { categorySeparator }
            <a
              href={category.link}
              className="h6 blog-post__cat-link"
            // onClick={() => { replaceSelected(category.id, category.taxonomy) }}
            >{category.name}</a>
          </Fragment>
        );
      }

    });
    categoriesElement = <div className="blog-post__cat">
      {categoryItems}
    </div>
  }

  if (post.the_author && displayAuthor) {
    author = <span className="author">By {post.the_author}</span>
  }

  if (post.excerpt && displayExcerpt) {
    excerpt = <div className="eight29-post-excerpt" dangerouslySetInnerHTML={{ __html: theExcerpt(post.excerpt.rendered) }}>
    </div>
  }

  if (displayDate) {
    date = <span className="blog-post__date">{post.formatted_date}</span>
  }

  if (post.acf_single_post_read_time) {
    postReadTime = <span
      className="blog-post__read"
      dangerouslySetInnerHTML={{ __html: post.acf_single_post_read_time }}></span>

  }

  return (
    <article id={`${postType}-${post.id}`} className="blog-post" >
      <a className="blog-post__link" href={post.link} aria-label="Post Link"></a>
      <div className="blog-post__wrapper">
        {featuredImage}
        <div className="blog-post__content">
          {categoriesElement}
          <h4 className="blog-post__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
          <p className="blog-post__meta">
            {date}
            {postReadTime}
          </p>
        </div>
      </div>
    </article>
  );
}

export default post;